import React from "react";
import WhatDo from "../components/What";

const What: React.FC = () => {
  return (
    <>
      <WhatDo />
    </>
  );
};

export default What;


